import { Navigate, Outlet } from 'react-router';

import { Loading, useData } from '@virtual-care/ui';

export default function HomecareLayout() {
  const {
    data: settings,
    isLoading,
    isError,
  } = useData('GET /settings/public', {}, { staleTime: Infinity });

  if (isLoading || isError) {
    return <Loading />;
  }

  if (settings?.homecareEnabled?.value !== 'true') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
